import { createContext, useContext, useState } from "react";

type AdminLoadingContextType = {
  showLoading: () => void;
  hideLoading: () => void;
  isLoading: boolean;
};

const AdminLoadingContext = createContext<AdminLoadingContextType | null>(null);

export function AdminLoadingProvider({ children }: { children: React.ReactNode }) {

  const [isLoading, setIsLoading] = useState(false);
  const showLoading = () => setIsLoading(true);
  const hideLoading = () => setIsLoading(false);

  return (
    <AdminLoadingContext.Provider
      value={{ isLoading, showLoading, hideLoading }}
    >
      {children}
    </AdminLoadingContext.Provider>
  );
};

export function useAdminLoading() {
  const context = useContext(AdminLoadingContext);
  if (!context) {
    throw new Error(
      "useAdminLoading must be used inside AdminLoadingProvider"
    );
  }
  return context;
};